/**
 * Keyboard-only skip link (WCAG 2.4.1 Bypass Blocks).
 * Off-screen by default; visible when focused.
 * Pages render their primary content inside `<main id="main-content">`.
 */
export const SkipToContent = () => (
  <a
    href="#main-content"
    className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:rounded-md focus:bg-primary focus:text-primary-foreground focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
  >
    Skip to main content
  </a>
);
